import type { FC } from 'react';

import ExoticsSabrBandContent from './exotics-sabr-band-content';
import type { ExoticsSabrBandProps } from './types';

const ExoticsSabrBandWidget: FC<ExoticsSabrBandProps> = ({ instrumentId }) => (
  <ExoticsSabrBandContent instrumentId={instrumentId} />
);

export default ExoticsSabrBandWidget;
